var dict = {};
dict["Hot dog"] = 350;
dict["Apple pie"] = 237;
dict["Baby back rib"] = 250;
dict["Baklava"] = 100;
dict["Beef carpaccio"] = 369;
dict["Beef tartare"] = 552;
dict["Beet salad"] = 161;
dict["Beignets"] = 240;
dict["Bibimbap"] = 503
dict["Bread pudding"] = 270;
dict["Breakfast burrito"] = 395;
dict["Bruschetta"] = 48;
dict["Caesar salad"] = 44;
dict["Cannoli"] = 374;
dict["Caprese salad"] = 220;
dict["Carrot cake"] = 118;
dict["Ceviche"] = 278;
dict["Cheesecake"] = 321;
dict["Cheese plate"] = 278;
dict["Chicken curry"] = 296;
dict["Chicken quesadilla"] = 269;
dict["Chicken wings"] = 520;
dict["Chocolate cake"] = 371;
dict["Chocolate mousse"] = 355;
dict["Churros"] = 237;
dict["Clam chowder"] = 134;
dict["Club sandwich"] = 591;
dict["Crab cakes"] = 160;
dict["Creme brulee"] = 210;
dict["Croque madame"] = 500;
dict["Cup cakes"] = 305;
dict["Deviled eggs"] = 200;
dict["Donuts"] = 450;
dict["Dumplings"] = 296;
dict["Edamame"] = 122;
dict["Eggs benedict"] = 728;
dict["Escargots"] = 90;
dict["Falafel"] = 333;
dict["Filet mignon"] = 267;
dict["Fish and chips"] = 840;
dict["Foie gras"] = 460;
dict["French fries"] = 310;
dict["French onion soup"] = 55;
dict["French toast"] = 237;
dict["Fried calamari"] = 154;
dict["Fried rice"] = 163;
dict["Frozen yogurt"] = 160;
dict["Garlic bread"] = 357;
dict["Gnocchi"] = 160;
dict["Greek salad"] = 102;
dict["Grilled cheese sandwich"] = 668;
dict["Grilled salmon"] = 360;
dict["Guacamole"] = 42;
dict["Gyoza"] = 186;
dict["Hamburger"] = 367;
dict["Hot and sour soup"] = 189;
dict["Hot dog"] = 150;
dict["Huevos rancheros"] = 431;
dict["Hummus"] = 160;
dict["Ice cream"] = 207;
dict["Lasagna"] = 135;
dict["Lobster bisque"] = 56;
dict["Lobster roll sandwich"] = 805;
dict["Macaroni and cheese"] = 310;
dict["Macarons"] = 102;
dict["Miso soup"] = 53;
dict["Mussels"] = 179;
dict["Nachos"] = 302;
dict["Omelette"] = 154;
dict["Onion rings"] = 481;
dict["Oysters"] = 197;
dict["Pad thai"] = 406;
dict["Paella"] = 341;
dict["Pancakes"] = 364;
dict["Panna cotta"] = 223;
dict["Peking duck"] = 421;
dict["Pho"] = 405;
dict["Pizza"] = 289;
dict["Pork chop"] = 236;
dict["Poutine"] = 1422;
dict["Prime rib"] = 290;
dict["Pulled pork sandwich"] = 417;
dict["Ramen"] = 397;
dict["Ravioli"] = 502;
dict["Red velvet cake"] = 305;
dict["Risotto"] = 604;
dict["Samosa"] = 262;
dict["Sashimi"] = 45;
dict["Scallops"] = 116;
dict["Seaweed salad"] = 137;
dict["Shrimp and grits"] = 206;
dict["Spaghetti bolognese"] = 354;
dict["Spaghetti carbonara"] = 370;
dict["Spring rolls"] = 154;
dict["Steak"] = 271;
dict["Strawberry shortcake"] = 321;
dict["Sushi"] = 250;
dict["Tacos"] = 361;
dict["Takoyaki"] = 426;
dict["Tiramisu"] = 496;
dict["Tuna tartare"] = 247;
dict["Waffles"] = 291;

export default function getCalories(s) {
	//t = s.toLowerCase();
	//t.charAt(0).toUpperCase();
	var t = s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
	return t + " has " + dict[t] + " calories.";
};




// WEBPACK FOOTER //
// ./src/dict.js